export default __webpack_public_path__ + "static/media/highlightRed.90cb9557.svg";